import * as React from 'react';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';

export default function UiTableWrapper(props) {
  
  return (
    <>
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table"  className='sbt-data-grid'>
            {props.children}
      </Table>
    </TableContainer>
    
   </>
  );
}